import styled from "styled-components";
import XIcon from "../../../assets/icons/x-close.svg";
import BOtagIcon from "../../../assets/icons/botag-icon-purple.svg";
import BOtagIconDisabled from "../../../assets/icons/botag-icon-disabled.svg";
import AppContext from "../../../AppContext";
import { useContext } from "react";

// #region SCOPED CSS
const StyledChatIcon = styled.div`
    &.chat-icon.disabled {
        cursor: not-allowed;
        opacity: 1;
    }
    &.chat-icon.enabled {
        cursor: pointer;
        opacity: 1;
    }

    &.chat-icon {
        display: flex;
        flex-direction: row;
        gap: 13.33px;
        align-items: center;
        justify-content: flex-start;
        position: relative;
    }

    .ellipse-14 {
        background: var(
            --botag-ai,
            linear-gradient(
                213.63deg,
                rgba(96, 226, 93, 1) 28.1884104013443%,
                rgba(97, 35, 228, 1) 49.97871816158295%,
                rgba(90, 195, 254, 1) 62.99999952316284%,
                rgba(34, 255, 255, 1) 99.50000047683716%
            )
        );
        border-radius: 50%;
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        position: absolute;
        left: 50%;
        translate: -50%;
        top: 0px;
        filter: blur(12px);
        aspect-ratio: 1;
    }
    .ellipse-13 {
        background: var(--backgrounds-and-lines-n-500, #141922);
        border-radius: 50%;
        flex-shrink: 0;
        width: 48px;
        height: 48px;
        position: relative;
        aspect-ratio: 1;
    }
    .x-close {
        flex-shrink: 0;
        width: 18px;
        height: 18px;
        position: absolute;
        left: 53%;
        translate: -50% -50%;
        top: 47%;
        overflow: visible;
        aspect-ratio: 1;
        transition: opacity 0.3s ease;
        opacity: 0;
        pointer-events: none;
    }
    .x-close.visible {
        opacity: 1;
        pointer-events: auto;
    }

    &.chat-icon.disabled .ellipse-14 {
        background: #4f5b6d;
        filter: blur(8px);
    }
    /*&.chat-icon.disabled .ellipse-13 {
        background: #2C323E;
    }*/
`;
// #endregion

/** ChatIcon renders a floating chat icon that toggles between open and closed states.
 * @component
 * @returns {JSX.Element} The rendered chat icon with toggle functionality.
 */
export default function ChatIcon() {
    // #region VARS

    const { aiChatWindowOpen, aiChatSidePanelOpen, setAiChatSidePanelOpen, aiChatIsDisabled } = useContext(AppContext);
    // #endregion

    // #region METHODS
    const toggleChatWindow = () => {
        if (aiChatIsDisabled) setAiChatSidePanelOpen(false);
        else setAiChatSidePanelOpen(!aiChatSidePanelOpen);
    };
    // #endregion

    return (
        <StyledChatIcon
            className={`chat-icon ${aiChatWindowOpen ? "opened" : "closed"} ${aiChatIsDisabled ? "disabled" : "enabled"}
            ${aiChatSidePanelOpen ? "hidden" : "visible"}
            `}
            onClick={toggleChatWindow}>
            <div className="ellipse-14"></div>
            <div className="ellipse-13"></div>
            <img
                className={`x-close ${aiChatWindowOpen || aiChatSidePanelOpen ? "visible" : ""}`}
                src={XIcon}
                alt="Close Icon"
            />
            <img
                className={`x-close ${!aiChatWindowOpen || aiChatSidePanelOpen ? "visible" : ""}`}
                //src={BOtagIcon}
                src={aiChatIsDisabled ? BOtagIconDisabled : BOtagIcon}
                alt="Chat Icon"
            />
        </StyledChatIcon>
    );
}
